<template>
    <div class="selection-box-item" :class="{'has-datas': machineDatas}">
        <span class="default-text">
            <template v-if="isBase">
                {{ $t("reference_machine") }}
            </template>
            <template v-else>
                {{ $tc("machine_number", number) }}
            </template>
        </span>
        <div class="machine-datas" v-if="machineDatas">
            <div class="left-part">
                <span class="action-plus-minus-button minus" @click="$emit('productSelected', machineDatas)"></span>
            </div>
            <div class="right-part">
                <span class="model-name">{{ machineDatas['Model'] }}</span>
                <span class="brand-name">{{ machineDatas['Manufacturer'].toLowerCase() }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import compareMixins from "@/common/mixins/compare";

    export default {
        name: 'SelectionBoxItem',
        mixins: [
          compareMixins
        ],
        props: {
            isBase: {
                type: Boolean,
                default: true
            },
            number: {
                type: Number,
                default: null
            },
            machineDatas: {
                type: Object,
                default: null
            }
        },
    }
</script>

<style lang="scss">
    .selection-box-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 74px;
        margin-bottom: 20px;
        border: dashed 4px $medium-grey;
        border-radius: 20px;

        &.has-datas {
            background-color: $white;
            border: solid 4px $white;

            .default-text {
                display: none;
            }

            .machine-datas {
                display: flex;
            }
        }

        .default-text {
            display: inline-block;
            font-size: 18px;
            font-weight: 700;
            color: $medium-grey;
        }

        .machine-datas {
            display: none;
            text-align: center;
            width: 100%;

            .left-part {
                flex: 0 0 34px;
                margin: 0 27px 0 23px;
            }

            .right-part {
                flex: 1 1 auto;
                text-align: left;

                .model-name {
                    display: block;
                    margin-bottom: 3px;
                }

                .brand-name {
                    text-transform: capitalize;
                    color: $medium-grey;
                }
            }
        }
    }
</style>